module.exports = __webpack_public_path__ + "static/touchdown-on-the-red-planet-f1a438b109cedc38eb3a549f85defd7f.jpg";